var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'show-cover',
    ( _obj = {
        'has-border': _vm.hasBorder,
        'has-image': _vm.show.cover.imageUrl,
        'is-invalid': !_vm.show.isValid
    }, _obj[("is-size-" + _vm.size)] = !!_vm.size, _obj[_vm.borderColor] = _vm.hasBorder, _obj )
]},[(_vm.show.cover.imageUrl && _vm.show.isValid)?_c('img',{class:[{ 'image-error': _vm.hasImageError }],attrs:{"src":_vm.show.cover.imageUrl},on:{"error":_vm.imageLoadError}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }